// extracted by mini-css-extract-plugin
module.exports = {"container":"PremiumDesktopGallery_container__eOTrW","image":"PremiumDesktopGallery_image__8EtDA"};